










import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

@Component({
  components: {
    ValidationProvider,
  },
})
export default class ValidateParts extends Vue {
  @Prop({ default: null }) value: any;
  @Prop({ default: () => ({}) }) rules!: object;
  @Prop({ default: '' }) vid!: string;
  @Prop({ default: '' }) name!: string;
  @Prop({ default: null }) isDisplayErrors?: boolean;
  @Prop({ default: false }) immediate: boolean;
  @Prop({ default: 'text-xxs' }) errorDisplaySize: string;
  displayErrors(errors) {
    if (this.isDisplayErrors !== null) {
      return errors.length && this.isDisplayErrors;
    }

    return errors.length;
  }
}
